import React from "react";
import { ImgV2 } from "../../../ImgV2";
export const CheckOutButton = ({ title, iconUrl, linkUrl }) => (React.createElement("a", { href: linkUrl, className: "caption-risk-warning-bold" },
    React.createElement("p", { className: "button-title" }, title),
    React.createElement(ImgV2, { src: iconUrl, alt: iconUrl })));
